import { z } from 'zod';
import { AgenticPlatformMessageSchema } from './message.js';
import { AgentModelSchema } from '../model.js';
import { AgentOutputJsonSchemaSchema, AgentThinkingLevelSchema } from '../session/run.js';
/**
 * Thread-scoped metadata that is passed to tools but never shown to the model.
 *
 * @see https://docs.ag-ui.com/sdk/js/core/types#context
 */
export const AgenticPlatformContextSchema = z.object({
    description: z.string(),
    value: z.string(),
});
/** A tool the frontend offers to execute on the agent's behalf. */
export const AgenticPlatformToolSchema = z.object({
    description: z.string(),
    name: z.string(),
    parameters: z.json().optional(),
});
/**
 * Platform-specific run knobs carried in the AG-UI `forwardedProps` escape hatch.
 *
 * `outputSchema` has no equivalent in the protocol, which models a conversation rather than a
 * task with a required answer. The run streams normally and the validated output arrives as the
 * `RUN_FINISHED` result, so a caller can watch the agent conform its answer to the schema.
 *
 * Unknown properties are preserved so frontends can forward data the platform does not
 * yet interpret.
 */
export const AgenticPlatformForwardedPropsSchema = z.looseObject({
    model: AgentModelSchema.optional(),
    outputSchema: AgentOutputJsonSchemaSchema.optional(),
    thinkingLevel: AgentThinkingLevelSchema.optional(),
});
/**
 * The AG-UI run request body.
 *
 * `threadId` doubles as the agent session identifier, so it must be a UUID. Conversation
 * history lives in the session rather than the request: `messages` is used only to read the
 * turn's new user input, and the platform remains the source of truth for everything before it.
 *
 * @see https://docs.ag-ui.com/sdk/js/core/types#runagentinput
 */
export const AgenticPlatformRunAgentInputSchema = z.object({
    context: z.array(AgenticPlatformContextSchema).default([]),
    forwardedProps: AgenticPlatformForwardedPropsSchema.optional(),
    messages: z.array(AgenticPlatformMessageSchema).default([]),
    runId: z.string().min(1),
    state: z.json().optional(),
    threadId: z.uuid(),
    tools: z.array(AgenticPlatformToolSchema).default([]),
});
//# sourceMappingURL=runInput.js.map